import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './facebookLiveFeed.css';
import * as FBLiveActions from './FacebookLiveActions';
import { fetchInitialData } from "../fetchData";
import Service from '../service/Service';
import withContext from "../../withContext";

const service = new Service();

class FacebookLiveFeed extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let FBListingData = [];
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            FBListingData = window.__initialData__['initialData'];
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                FBListingData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("FBListingData:::", FBListingData);
        if(FBListingData && FBListingData['msg'] == "1" && FBListingData['result']){
            initialData = FBListingData['result']
        }

        if (this.props.location.search.includes('from=app')) {
           var isApp=true;
        }else{
           var isApp=false;
        }


        this.state ={
            FBListingData : initialData,
            isApp:isApp
        }
    }
    static initialAction(reqUrl, ftk, authData, uId, childData, cookie) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        
        let url = global.api_url + "fb/fblivelisting";
        let body = JSON.stringify({
            "pageno":"1",
 	        "pagesize":"1000"
        });
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount(){
        document.addEventListener("click", FBLiveActions.domClick);
        this.setState({
            resolution : window.innerWidth
        });
        service.showLoader();
        // debugger;
        if (navigator.onLine) {
            if (!this.state.FBListingData || (this.state.FBListingData && this.state.FBListingData.length < 1)) {
                // service.showLoader();
                this.fbliveListingData();
            } else {
                localStorage.setItem('FBListingData', JSON.stringify(this.state.FBListingData));
            }
        } else {
            if (localStorage.getItem('FBListingData')) {
                this.setState({ FBListingData: JSON.parse(localStorage.getItem('FBListingData'))});
            }
        }
        service.hideLoader();
    }
    fbliveListingData(){
        var url = global.api_ci_url + "FacebookLiveFeed/getfbListingData";
        let postdata = {};
        service.postServiceCall(url, postdata).then((json) => {
            if (json['msg'] == "1") {
                this.setState({ FBListingData : json['result'] });
                localStorage.setItem('FBListingData', JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    
    // reloadData(videoId){
    //     // var _this = this;
    //     setTimeout(() => {
    //         // debugger
    //         var newListingData = this.state.FBListingData;
    //         for(let i = 0; i < newListingData.length; i++){
    //             if(newListingData[i]['videoId'] == videoId){
    //                 newListingData[i]['isShowRegisterBtn'] = 'false';
    //             }
    //         }
    //         this.setState({ FBListingData: newListingData });
    //     }, 200);
    // }

    render() {
        return (
            <main className="facebookLive main-container">
                <Helmet
                    title='Live Expert Sessions, Seminars and Workshops | FirstCry Parenting'
                    meta={[
                        { "name": "description", "content": "Watch live expert sessions on parenting, pregnancy, breastfeeding, child development, care, food, nutrition, and safety tips. Please register and stay tuned." },
                        { "name": "keywords", "content": "Live Expert Sessions" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Expert Sessions</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>FirstCry Parenting Live Expert Sessions</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="live-sessions">
                            <div className="top-register-msg R18_61">
                                Here is the list of <span className="M18_42">Firstcry Parenting Camp Expert Live Sessions.</span><br /> Please register and stay tuned.
                            </div>
                            <ul className="live-sessions-list">
                            {this.state.FBListingData && this.state.FBListingData.map((FBlisting, index) => 
                                <li key={index} className={`session_${FBlisting.videoId}`}>
                                    <div className="bannerimg left">
                                        <img  onClick={(e) => FBLiveActions.getRedirectUrl(FBlisting.videoTitle, FBlisting.videoId,e)} src={FBlisting.bannerUrl.replace("http://", "https://")} />
                                    </div>
                                    <div className="left session-info">
                                        <div onClick={(e) => FBLiveActions.getRedirectUrl(FBlisting.videoTitle, FBlisting.videoId,e)} className="M15_42 sessiontopic">{FBlisting.videoTitle}</div>
                                        <div className="exp-name R15_9e">with <span className="M15_42">{FBlisting.expertName}</span></div>
                                        <div className="R15_9e">{FBLiveActions.getSessionDate(FBlisting.DateTime, "datetime")}</div>
                                        {this.state.resolution < 768 ?
                                        (FBlisting.isShowRegisterBtn ? 
                                            <div className="register-btn M14_white" onClick={(e) => FBLiveActions.registerNow(FBlisting.videoTitle, FBlisting.videoId, this.state.isApp, e)}>Register Now</div> 
                                            :
                                            <div className="register-btn regbtn-disable M14_white">You Are Registered</div>) : null
                                        }
                                    </div>
                                    {this.state.resolution >= 768 ?
                                    (FBlisting.isShowRegisterBtn ?
                                    <div className="register-btn M14_white" onClick={(e) => FBLiveActions.registerNow(FBlisting.videoTitle, FBlisting.videoId, this.state.isApp, e)}>Register Now</div>
                                    :
                                    <div className="register-btn regbtn-disable M14_white">You Are Registered</div>) : null
                                    }
                                </li>
                                )}
                            </ul>
                        </div>
                        <div className="alertMsg-overlay fblivemsg-overlay"><div className="alert-popup"><span className="alertmsg fblivemsg"></span></div></div>
                    </div>
                </div>
            </main>
        )
    }
}

export default withContext(FacebookLiveFeed);
